import { api } from "./api";

export const addBanner = async (formData) => {
  let url = `/banner/add`;
  return await api.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const Bannerlist = async (addUrl = '') => {
  let url = `/banner/list?${addUrl}`;
  return await api.get(url);
};
export const BannerDelete = async (addUrl = '') => {
  let url = `/banner/delete/${addUrl}`;
  return await api.get(url);
};
export const BannerStatus = async (data = {}) => {
  let url = `/banner/update-status`;
  return await api.post(url, data);
};
